import {THREE_D_ONLY_EDITOR} from '../lib/three-d-editor-mode';

const STAGE_VIEW_MODES = {
    twoD: 'twoD',
    threeD: 'threeD'
};

const SET_STAGE_VIEW_MODE = 'scratch-gui/stage-view-mode/SET_STAGE_VIEW_MODE';

const initialState = {
    mode: THREE_D_ONLY_EDITOR ? STAGE_VIEW_MODES.threeD : STAGE_VIEW_MODES.twoD
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_STAGE_VIEW_MODE:
        return {
            mode: THREE_D_ONLY_EDITOR ? STAGE_VIEW_MODES.threeD : action.mode
        };
    default:
        return state;
    }
};

const setStageViewMode = function (mode) {
    return {
        type: SET_STAGE_VIEW_MODE,
        mode: mode
    };
};

export {
    reducer as default,
    initialState as stageViewModeInitialState,
    STAGE_VIEW_MODES,
    setStageViewMode
};
